import styled from '@emotion/styled';
import { colorPalette } from '@sharefiledev/antd-config';
import { Flex, Input, Typography } from 'antd';
import { SignatureAreaDimensions } from '../constants';

const { Paragraph } = Typography;

export const StyledSignatureTypeWrapper = styled(Flex)`
	padding: 0;
	position: relative;
`;

export const StyledSignatureInputWrapper = styled(Flex)`
	height: ${SignatureAreaDimensions.height}px;
	border-width: 1px !important;
	border-style: solid;
	border-color: ${colorPalette.neutral7};
	:hover {
		border-color: ${colorPalette.lavender6};
		box-shadow: ${colorPalette.lavender6} 0 0 0 1px;
	}
	:focus-within {
		border-color: ${colorPalette.pink10};
		box-shadow: ${colorPalette.pink10} 0 0 0 1px;
	}
`;

export const StyledSignatureInput = styled(Input)<{ fontSize: any; penColor: any }>(
	{
		fontFamily: `'Cedarville Cursive', 'cursive'`,
		paddingLeft: '2px',
		boxSizing: 'border-box',
		borderRadius: 0,
		height: `${SignatureAreaDimensions.height}px`,
		width: '100%',
		border: '0 !important',
		boxShadow: 'none !important',
	},
	props => ({
		fontSize: props.fontSize,
		color: props.penColor,
	})
);

export const HiddenResizer = styled(Paragraph)<{ fontSize: number }>(
	{
		visibility: 'hidden',
		position: 'absolute',
		right: 0,
		bottom: 0,
		fontFamily: 'Cedarville Cursive',
	},
	props => ({
		fontSize: props.fontSize + 'px',
	})
);
